import axios from 'axios'
import { signatureKey, tokenKey } from 'consts'

class WebApi {
  constructor() {
    var APIURL = process.env.REACT_APP_WEB_URL
    this.WebApi = axios.create({
      baseURL: APIURL,
      timeout: 20000,
      withCredentials: true,
      params: {
        cache: Math.random(),
      },
    })
    this.WebApi.defaults.headers.common['Cache-Control'] = 'no-cache'
    this.WebApi.defaults.headers.common['Pragma'] = 'no-cache'
    this.WebApi.defaults.headers.common['Expires'] = '0'
    if (typeof window == 'undefined') return
    this.authToken = localStorage.getItem(tokenKey) || null
    this.setSignature()

    this.setToken(this.authToken)
  }

  call = (method, ...params) => {
    return this.WebApi[method](...params)
  }

  getData = res => res.data

  logOut() {
    this.setToken(null)
  }

  setSignature() {
    if (localStorage.getItem(signatureKey)) {
      this.WebApi.defaults.headers.common['CartSignature'] =
        localStorage.getItem(signatureKey)
    } else {
      const signature =
        new Date().getTime() + Math.round(Math.random() * 1000000)
      localStorage.setItem(signatureKey, signature)
      this.WebApi.defaults.headers.common['CartSignature'] = signature
    }
    return this
  }

  setToken(token) {
    if (token) {
      this.authToken = token
      this.WebApi.defaults.headers.common['Authorization'] = `Bearer ${token}`
      localStorage.setItem(tokenKey, token)
    } else {
      this.authToken = undefined
      this.WebApi.defaults.headers.common['Authorization'] = ''
      localStorage.removeItem(tokenKey)
    }
    return this
  }
}

export default new WebApi()
